import { useSyncExternalStore } from "react";

/**
 * Whether the arrow links that open another record (OpenRecord in the apps)
 * open it in a new tab. A per-device preference, like the theme: kept in this
 * browser, set on the account page. A plain click on a row's own link is not
 * affected.
 */
const KEY = "dl.preference.record-links-new-tab";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setRecordLinksInNewTab(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, "1");
    else window.localStorage.removeItem(KEY);
  } catch {
    // Storage refused (private window): the choice lasts for this page only.
  }
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  // Another tab changing it.
  const onStorage = (event: StorageEvent) => {
    if (event.key === KEY) listener();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", onStorage);
  };
}

export function useRecordLinksInNewTab(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
